export const DEFAULT_TABLE_ROW_HEIGHT_PX = 52;

/** Default client page size for `pagination.mode === 'client'`. */
export const DEFAULT_CLIENT_PAGE_SIZE = 25;

export const MIN_SHELL_PAGE_SIZE = 5;
export const MAX_SHELL_PAGE_SIZE = 100;
export const HEADER_ROW_FALLBACK_PX = 48;
export const PAGINATION_FOOTER_FALLBACK_PX = 56;
export const SHELL_PAGE_SIZE_PAD_PX = 4;

export const DATATABLE_PAGINATED_HEIGHT_CAP =
  'var(--wp-datatable-max-height, min(70dvh, calc(100dvh - 14rem)))' as const;

/** Auto-enable row virtualization at or above this count (embedded scroll lists). */
export const VIRTUALIZE_ROW_THRESHOLD = 50;
